import { useEffect, useState } from 'react';

/**
 * Tracks whether the SLD tab is active and the browser tab is focused.
 * Returns `isVisible` — true when both conditions are met.
 */
export function useSLDVisibility(tabActive: boolean): boolean {
  const [documentVisible, setDocumentVisible] = useState(!document.hidden);

  useEffect(() => {
    const handler = () => setDocumentVisible(!document.hidden);
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);

  return tabActive && documentVisible;
}
